import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '@app/constants';
import { View, Text } from '@/styles/reactnative';
import { CButton } from '../Common';

const AuthCheckText = () => {
  const navigation = useNavigate();
  const { t, i18n } = useTranslation();
  const isKo = i18n.language === 'ko';
  return (
    <View
      style={{
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        color: '#fff',
        gap: 4,
        fontFamily: 'NanumSquareRound',
        fontWeight: 700,
        fontSize: 14,
        letterSpacing: -0.28,
      }}
    >
      <CButton
        title={t('login')}
        onClick={() => {
          navigation('/login');
        }}
        style={{ color: '#07D993',fontFamily: 'NanumSquareRound',
          fontWeight: 700,
          fontSize: 15,
          letterSpacing: -0.28, }}
      />
      <Text>{t('or')}</Text>
      <CButton
        title={t('signUp')}
        onClick={() => {
          navigation('/signup');
        }}
        style={{ color: '#07D993',fontFamily: 'NanumSquareRound',
          fontWeight: 700,
          fontSize: 15,
          letterSpacing: -0.28, }}
      />
      <Text>{isKo ? '후 Piecrip 계속하기' : 'to continue with Piecrip'}</Text>
    </View>
  );
};

export default AuthCheckText;
